import React, { useState } from "react";
import { toast } from "react-toastify";
import AsyncSelect from "react-select/async";
import _ from "lodash";
import { api } from "../utils";

const ITEM_LOAD_FAILED_MESSAGE = "There was an error loading item information.";
// The lookup runs on every keystroke, so a failing service would otherwise stack one toast per key.
const ITEM_LOAD_TOAST_ID = "machine-part-typeahead-load";

export default function MachinePartTypeahead(props) {
   const [inputValue, setInputValue] = useState("");

   const loadItemOptions = (typedValue, callback) => {
      if (!typedValue || !typedValue.length || typedValue.length < 2) {
         return;
      }
      let payload = { ItemNumber: typedValue };
      api
         .post("SewingTech/GetMachinePartsByItemNumber", payload)
         .then((response) => {
            if (api.toastFailure(response, ITEM_LOAD_FAILED_MESSAGE, ITEM_LOAD_TOAST_ID)) {
               callback([]);
               return;
            }
            let list = _.map(response.data.list, (d) => {
               d.label = d.itemWithDesc;
               d.value = d.itemNumber;
               // need all the values for other
               return d;
            });
            callback(list);
         })
         .catch(() => {
            toast.error(ITEM_LOAD_FAILED_MESSAGE, { toastId: ITEM_LOAD_TOAST_ID });
            callback([]);
         });
   };

   function selectItem(e) {
      props.onChange(e);
      if (!e || !e.length > 0)
         return 0;

      let payload = { ItemNumberSearch: e.itemNumber };
      api
         .post("SewingTech/GetDefaultWorkOrderPricing", payload)
         .then((response) => {
            let price = response.data;
            return price;
         })
         .catch(() => {
            return 0;
         });
   }

   return (
      <AsyncSelect
         classNamePrefix="serviceThreadSelect"
         loadOptions={loadItemOptions}
         onInputChange={(e) => setInputValue(e)}
         onChange={selectItem}
         inputValue={inputValue}
         value={props.value}
         isDisabled={props.disabled}
         onFocus={props.onFocus}
         placeholder={props.placeholder || "Type the item number you are looking for"}
         isClearable
      />
   );
}
